<!-- Desktop Sidebar -->
@if (visible) {
  <!-- Sidebar -->
  <aside class="w-64 h-full bg-gray-800 border-r flex-shrink-0">
    <nav class="p-4 h-full overflow-y-auto flex flex-col">
      <div class="flex-1">
        <p-divider align="left">
          <span class="text-label-md">{{ 'home.navigation' | translate }}</span>
        </p-divider>
        <!-- Navigation menu items -->
        <div class="flex flex-col gap-2">
          <a 
            routerLink="/dashboard"
            routerLinkActive="active-nav-button"
            [routerLinkActiveOptions]="{ exact: true }"
            pButton
            outlined
            icon="pi pi-home"
            label="Dashboard"
            class="p-button-fluid !justify-start">
          </a>
          
          <a 
            routerLink="/users"
            routerLinkActive="active-nav-button"
            pButton
            outlined
            icon="pi pi-users"
            [label]="'users.title' | translate"
            class="p-button-fluid !justify-start">
          </a>
          
          <a 
            routerLink="/projects"
            routerLinkActive="active-nav-button"
            pButton
            outlined
            icon="pi pi-briefcase"
            [label]="'projects.title' | translate"
            class="p-button-fluid !justify-start">
          </a>
          
          <a 
            routerLink="/success-stories"
            routerLinkActive="active-nav-button"
            [routerLinkActiveOptions]="{ exact: true }"
            pButton
            outlined
            icon="pi pi-bookmark"
            [label]="'successStories.title' | translate"
            class="p-button-fluid !justify-start">
          </a>
          
          <a 
            routerLink="/learn-more"
            routerLinkActive="active-nav-button"
            [routerLinkActiveOptions]="{ exact: true }"
            pButton
            outlined
            icon="pi pi-book"
            [label]="'learnMore.title' | translate"
            class="p-button-fluid !justify-start">
          </a>
          
          <a 
            routerLink="/community"
            routerLinkActive="active-nav-button"
            [routerLinkActiveOptions]="{ exact: true }"
            pButton
            outlined
            icon="pi pi-share-alt"
            [label]="'community.title' | translate"
            class="p-button-fluid !justify-start">
          </a>
        </div>
      </div>
      
      <!-- Logout button at the bottom -->
      <div class="mt-auto pt-4">
        <p-divider></p-divider>
        <a 
          (click)="logout()"
          pButton
          [outlined]="true"
          icon="pi pi-sign-out"
          [label]="'common.logout' | translate"
          class="p-button-fluid !justify-start p-button-danger">
        </a>
      </div>
    </nav>
  </aside>
}